// CookieConsent.js
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import gifCookie from "../Images/gifCookie.gif";
import "../App.css";

const CookieConsent = () => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState(false);
  const [hasConsented, setHasConsented] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (consent === null) {
      setIsVisible(true);
    } else {
      setHasConsented(consent === "true");
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
    setHasConsented(true);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "false");
    setIsVisible(false);
    setHasConsented(false);
  };

  return (
    isVisible && (
      <div className="cookie-consent-modal cookie-consent-backdrop">
        <div className="cookie-consent-banner">
          <div className="cookie-banner-svg">
            <img src={gifCookie} alt="" />
          </div>
          <div className="cookie-consent-banner__description">
            We use cookies to ensure that we give you the best experience on our website. If you
            continue to use this site we will assume that you are happy with it.
          </div>
          <div className="cookie-button-wrapper">
            <button onClick={handleAccept} className="cookie-consent-button">
              Accept all
            </button>
            <button onClick={handleReject} className="cookie-consent-button">
              Reject
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default CookieConsent;
